import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@application/auth/auth.service';
import { environment } from 'environments/environment';
import { MenuItem } from 'primeng/api';
import { TieredMenu } from 'primeng/tieredmenu';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  imports: [TieredMenu, RouterLink, CommonModule]
})
export class TopbarComponent implements OnInit {
  itensMenu: MenuItem[] = [
    {
      id: '4',
      label: 'Sair',
      icon: 'pi pi-sign-out',
      command: () => this.exit()
    }
  ];

  env: any;
  authService = inject(AuthService);
  user = this.authService.usuario();

  ngOnInit() {
    this.env = environment;
  }

  exit() {
    this.authService.logout();
  }
}
